import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import IntroHydroluz from "./IntroHydroluz";
import "./CustomSwiper.css";

const CustomSwiper = () => {
  const navigate = useNavigate();

  const slides = [
    {
      type: "component",
      component: <IntroHydroluz />,
    },
    {
      type: "image",
      image: require("../../static/media/swiper/swiper1.webp"),
      className: "slide1-button",
      button: (
        <button onClick={() => navigate("/categorias")} className="slide-button">
          Ver Productos
        </button>
      ),
    },
    {
      type: "css",
      className: "slide0-button",
      button: (
        <button onClick={() => navigate("/categorias")} className="slide-button">
          Comprar ahora
        </button>
      ),
    },
    {
      type: "image",
      image: require("../../static/media/swiper/swiper2.webp"),
      className: "slide2-button",
      button: (
        <button onClick={() => navigate("/contactos")} className="slide-button">
          Comunícate con Nosotros
        </button>
      ),
    },
  ];

  return (
    <div className="custom-swiper-container">
      <Swiper
        loop={true}
        autoplay={{ delay: 10000, disableOnInteraction: false }}
        modules={[Autoplay, Navigation, Pagination]}
        navigation
        pagination={{ clickable: true }}
      >
        {slides.map((slide, idx) => (
          <SwiperSlide key={idx}>
            {slide.type === "component" ? (
              <div className="component-slide-wrapper">{slide.component}</div>
            ) : slide.type === "css" ? (
              <div className="css-slide">
                <motion.div
                  initial={{ opacity: 0, y: 24 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  className="css-slide-content"
                >
                  <div className="css-slide-text">
                    <h2 className="css-slide-title">Hidrosanitarios, ferretería y más</h2>
                    <p className="css-slide-subtitle hide-on-mobile">
                      Encuentra todo lo que necesitas para tu hogar y obra.
                    </p>
                      <ul className="css-slide-list hide-on-mobile">
                        <li>· Material hidrosanitario de calidad</li>
                        <li>· Productos ferreteros para tu proyecto</li>
                        <li>· Artículos para el hogar, herramientas y más</li>
                        <li>· Atención personalizada y envío rápido</li>
                      </ul>
                    <p className="css-slide-extra hide-on-mobile">
                      Compra fácil, rápido y con confianza. Explora nuestras categorías ahora.
                    </p>
                    <div className={slide.className}>{slide.button}</div>
                  </div>

                  <div className="css-slide-image-container">
                    <div className="css-slide-image-mask">
                      <img
                        src={require("../../static/media/swiper/swiper.webp")}
                        alt="Hydroluz presentación"
                        className="css-slide-image"
                      />
                    </div>
                  </div>
                </motion.div>
              </div>
            ) : (
              <div className="slide-wrapper">
                <img
                  src={slide.image}
                  alt={`Slide ${idx + 1}`}
                  className="slide-image"
                />
                <div className={slide.className}>{slide.button}</div>
              </div>
            )}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default CustomSwiper;